export default {
  learn: {
    description: 'We educate, by providing a free and approachable curriculum teaching fundamentals of robotics while illustrating its parallels with other STEM fields.',
    icon: './../../public/images/icons/learn.svg',
    title: 'Learn'
  },
  build: {
    description: 'We activate, by mentoring stereotype-breaking citizens as they apply new skills to create exciting, interactive art and engineering installations.',
    icon: './../../public/images/icons/build.svg',
    title: 'Build'
  },
  share: {
    description: 'We iterate, by supporting new learners as they pursue STEM knowledge while paying it forward to the community at large.',
    icon: './../../public/images/icons/share.svg',
    title: 'Share'
  }
}


// WEBPACK FOOTER //
// ./src/configs/about-config.js